import router from "@/router";
import { formatDateStringToString, formatExplanationRule, formatWorkTime, getInfoStaffFull } from "./commonUtils";
import { DATE_FORMAT_HM, OT_TYPES, ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY } from "./constants";

export const workScheduleConfigColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 65,
    align: "right",
  },
  {
    title: "Code",
    dataIndex: "work_schedule_code",
    key: "work_schedule_code",
    // width: 300,
    ellipsis: true,
  },
  {
    title: "Name",
    dataIndex: "work_schedule_name_vi",
    key: "name",
  },
  {
    title: "Work Start Time",
    dataIndex: "work_start_time",
    key: "work_start_time",
    customRender(value) {
      if (!value) return "";
      return formatDateStringToString(value, DATE_FORMAT_HM);
    },
    width: 200,
    align: "right",
  },
  {
    title: "Work End Time",
    dataIndex: "work_end_time",
    key: "work_end_time",
    customRender(value) {
      if (!value) return "";
      return formatDateStringToString(value, DATE_FORMAT_HM);
    },
    width: 200,
    align: "right",
  },
  {
    title: "Standard Working Time",
    dataIndex: "standard_working_time",
    key: "standard_working_time",
    customRender(value) {
      return `${value ?? 0} hour(s)`;
    },
    width: 200,
    // align: "right",
  },
  {
    title: "Minimum Working Time",
    dataIndex: "working_time",
    key: "working_time",
    customRender(value) {
      return `${value ?? 0} hour(s)`;
    },
    width: 200,
    // align: "right",
  },
  {
    title: "Break Time",
    dataIndex: "break_time",
    key: "break_time",
    customRender(value) {
      return `${value ?? 0} hour(s)`;
    },
    width: 200,
    align: "right",
  },
  {
    title: "Lack Of Time Allowed",
    dataIndex: "lack_of_time_allowed",
    key: "lack_of_time_allowed",
    customRender(value) {
      return `${value ?? 0} minute(s)`;
    },
    align: "right",
  },
  {
    title: "Continuous Working Time",
    dataIndex: "working_time_cal_break_time",
    key: "working_time_cal_break_time",
    customRender(value) {
      return `${value ?? 0} hour(s)`;
    },
    width: 250,
    align: "right",
  },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   width: 150,
  //   align: "right",
  // },
];

export const createEditWorkScheduleFlexible = [
  {
    title: "Day",
    dataIndex: "day",
    key: "day",
    width: 150,
  },
  {
    title: "Working Day",
    dataIndex: "workingDay",
    key: "workingDay",
    scopedSlots: {
      customRender: "workingDay",
    },
    width: 150,
    align: "center",
  },
  {
    dataIndex: "startTime",
    key: "startTime",
    scopedSlots: {
      customRender: "startTime",
    },
    slots: { title: "startTimeHeader" },
    width: 150,
  },
  {
    dataIndex: "endTime",
    key: "endTime",
    scopedSlots: {
      customRender: "endTime",
    },
    slots: { title: "endTimeHeader" },
    width: 150,
  },
  {
    dataIndex: "workingTime",
    key: "workingTime",
    scopedSlots: {
      customRender: "workingTime",
    },
    slots: { title: "workingTimeHeader" },
    width: 150,
  },
  {
    title: "Minimum Working Time",
    dataIndex: "minimumWorkingTime",
    key: "minimumWorkingTime",
    scopedSlots: {
      customRender: "minimumWorkingTime",
    },
    width: 150,
  },
  {
    dataIndex: "continuousWorkingTime",
    key: "continuousWorkingTime",
    scopedSlots: {
      customRender: "continuousWorkingTime",
    },
    slots: { title: "continuousWorkingTimeHeader" },
    width: 150,
  },
  {
    dataIndex: "breakTime",
    key: "breakTime",
    scopedSlots: {
      customRender: "breakTime",
    },
    slots: { title: "breakTimeHeader" },
    width: 150,
  },
];

export const policyManagementEmployeeColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 65,
    align: "right",
  },
  {
    title: "Employee",
    dataIndex: "fullName",
    key: "staff",
    ellipsis: true,
    customCell(row) {
      return {
        style: {
          color: "#0379B0",
          cursor: row?.staff ? "pointer" : "default",
        },
        on: {
          click: () => {
            if (!row?.staff) return;
            router.push({
              name: ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY,
              params: {
                id: row?.employee_id,
              },
            });
          },
        },
      };
    },
    isHideHistory: true,
  },
  {
    title: "Work Schedule Code",
    dataIndex: "work_schedule_code",
    key: "work_schedule_code",
    width: 200,
  },
  {
    title: "Work Schedule Type",
    dataIndex: "rule_type_name_vi",
    key: "workScheduleType",
    width: 170,
  },
  {
    title: "Time",
    dataIndex: "workSchedule",
    key: "time",
    customRender(workSchedule) {
      if (!workSchedule) return "";
      const { work_start_time, work_end_time } = workSchedule;
      return formatWorkTime(work_start_time, work_end_time);
    },
    width: 120,
  },
  // {
  //   title: "Standard Working Time",
  //   dataIndex: "workSchedule.standard_working_time",
  //   key: "workingTime",
  //   width: 180,
  //   customRender(standard_working_time) {
  //     return `${standard_working_time ?? 0} hour(s)`;
  //   },
  //   align: "center",
  // },
  {
    title: "Minimum Working Time",
    dataIndex: "workSchedule.working_time",
    key: "workingTime",
    width: 130,
    customRender(working_time) {
      return `${working_time ?? 0} hour(s)`;
    },
    // align: "right",
  },
  {
    title: "Explanation Rule",
    dataIndex: "explanationRule",
    key: "explanationRule",
    customRender(_, record) {
      return formatExplanationRule(record);
    },
    width: 360,
  },
  {
    title: "Lack Of Time Allowed",
    dataIndex: "lack_of_time_allowed",
    key: "lack_of_time_allowed",
    customRender(_, data) {
      var dataJson = JSON.stringify(data.workSchedule)
      dataJson = JSON.parse(dataJson)
      return `${dataJson.lack_of_time_allowed ?? 0} minute(s)`;
    },
    width: 180,
  },
  {
    title: "Overtime Rule",
    dataIndex: "ot_type",
    key: "overtimeRule",
    customRender(ot_type) {
      if (!ot_type) return "";
      return OT_TYPES.find((otType) => otType.value === ot_type)?.label ?? "";
    },
    width: 120,
  },
  {
    title: "Policy Link",
    dataIndex: "url_policy",
    key: "urlPolicy",
    width: 110,
    customRender(value) {
      return value ? "Link" : "";
    },
    customCell(row) {
      const { url_policy } = row;
      return {
        style: {
          color: "#0379B0",
          cursor: url_policy ? "pointer" : "default",
        },
        on: {
          click: () => {
            if (url_policy) {
              window.open(url_policy, "_blank");
            } else {
              return;
            }
          },
        },
      };
    },
  },
  {
    title: "Date Applied",
    dataIndex: "applyDateFormat",
    key: "dateApplied",
    width: 130,
    align: "center",
  },
  {
    title: "Date Expired",
    dataIndex: "expireDateFormat",
    key: "dateExpired",
    width: 130,
    align: "center",
  },
  // {
  //   title: "Action",
  //   dataIndex: "action",
  //   key: "action",
  //   scopedSlots: { customRender: "action" },
  //   width: 200,
  //   fixed: "right",
  //   align: "center",
  // },
];
export const policyManagementEmployeeHistoryColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 65,
    align: "right",
  },
  {
    title: "Work Schedule Code",
    dataIndex: "work_schedule_code",
    key: "work_schedule_code",
    width: 250,
    customRender(text, record) {
      const textRender = `${text} ${record.is_from === "default_hrms" ? "(Default)" : ""}`;
      return textRender;
    },
  },
  {
    title: "Work Schedule Type",
    dataIndex: "rule_type_name_vi",
    key: "workScheduleType",
    width: 200,
  },
  {
    title: "Time",
    dataIndex: "workSchedule",
    key: "time",
    customRender(workSchedule) {
      if (!workSchedule) return "";
      const { work_start_time, work_end_time } = workSchedule;
      return formatWorkTime(work_start_time, work_end_time);
    },
    width: 110,
  },
  // {
  //   title: "Standard Working Time",
  //   dataIndex: "workSchedule.standard_working_time",
  //   key: "workingTime",
  //   width: 180,
  //   customRender(standard_working_time) {
  //     return `${standard_working_time ?? 0} hour(s)`;
  //   },
  //   align: "center",
  // },
  {
    title: "Minimum Working Time",
    dataIndex: "workSchedule.working_time",
    key: "workingTime",
    width: 120,
    customRender(working_time) {
      return `${working_time ?? 0} hour(s)`;
    },
    // align: "center",
  },
  {
    title: "Explanation Rule",
    dataIndex: "explanationRule",
    key: "explanationRule",
    customRender(_, record) {
      return formatExplanationRule(record);
    },
    width: 380,
  },
  {
    title: "Lack Of Time Allowed",
    dataIndex: "lack_of_time_allowed",
    key: "lack_of_time_allowed",
    customRender(_, data) {
      var dataJson = JSON.stringify(data.workSchedule)
      dataJson = JSON.parse(dataJson)
      return `${dataJson.lack_of_time_allowed ?? 0} minute(s)`;
    },
    width: 200,
  },
  {
    title: "Overtime Rule",
    dataIndex: "ot_type",
    key: "overtimeRule",
    customRender(ot_type) {
      if (!ot_type) return "";
      return OT_TYPES.find((otType) => otType.value === ot_type)?.label ?? "";
    },
    width: 120,
  },
  {
    title: "Policy Link",
    dataIndex: "url_policy",
    key: "urlPolicy",
    width: 120,
    customRender(value) {
      return value ? "Link" : "";
    },
    customCell(row) {
      const { url_policy } = row;
      return {
        style: {
          color: "#0379B0",
          cursor: url_policy ? "pointer" : "default",
        },
        on: {
          click: () => {
            if (url_policy) {
              window.open(url_policy, "_blank");
            } else {
              return;
            }
          },
        },
      };
    },
  },
  {
    title: "Date Applied",
    dataIndex: "applyDateFormat",
    key: "dateApplied",
    width: 120,
    align: "center",
  },
  {
    title: "Date Expired",
    dataIndex: "expireDateFormat",
    key: "dateExpired",
    width: 130,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 200,
    fixed: "right",
    align: "center",
  },
];

export const policyManagementDepartmentColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 65,
    align: "right",
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
    ellipsis: true,
    customCell(row) {
      return {
        style: {
          color: "#0379B0",
          cursor: "pointer",
        },
        on: {
          click: () => {
            router.push({
              name: ROUTER_PAGE_POLICY_MANAGEMENT_EMPLOYEE_HISTORY,
              params: {
                id: row?.id,
              },
            });
          },
        },
      };
    },
  },
  {
    title: "Work Schedule Code",
    dataIndex: "workScheduleCode",
    key: "workScheduleCode",
    width: 250,
  },
  {
    title: "Work Schedule Type",
    dataIndex: "workScheduleType",
    key: "workScheduleType",
    width: 150,
  },
  {
    title: "Time",
    dataIndex: "time",
    key: "time",
    width: 150,
  },
  {
    title: "Working Time",
    dataIndex: "workingTime",
    key: "workingTime",
    width: 150,
    align: "center",
  },
  {
    title: "Explanation Rule",
    dataIndex: "explanationRule",
    key: "explanationRule",
    width: 300,
    align: "right",
  },
  {
    title: "Date Applied",
    dataIndex: "dateApplied",
    key: "dateApplied",
    width: 150,
    align: "center",
  },
  {
    title: "Date Expired",
    dataIndex: "dateExpired",
    key: "dateExpired",
    width: 150,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 200,
    fixed: "right",
    align: "center",
  },
];

export const reportPolicyMappingColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 65,
    align: "right",
  },
  {
    title: "Staff",
    dataIndex: "staff",
    key: "staff",
    ellipsis: true,
    customRender(value) {
      return getInfoStaffFull(value);
    },
  },
  {
    title: "Work Schedule Code",
    dataIndex: "work_schedule_code",
    key: "workScheduleCode",
    width: 180,
  },
  {
    title: "Work Schedule Name",
    dataIndex: "workSchedule",
    key: "workScheduleName",
    customRender(workSchedule) {
      if (!workSchedule) return "";
      return workSchedule?.work_schedule_name_vi ?? "";
    },
    width: 180,
  },
  {
    title: "Work Schedule Type",
    dataIndex: "rule_type_name_vi",
    key: "workScheduleType",
    width: 160,
  },
  {
    title: "Time",
    dataIndex: "workSchedule",
    key: "time",
    customRender(workSchedule) {
      if (!workSchedule) return "";
      const { work_start_time, work_end_time } = workSchedule;
      return formatWorkTime(work_start_time, work_end_time);
    },
    width: 110,
  },
  {
    title: "Minimum Working Time",
    dataIndex: "workSchedule.working_time",
    key: "workingTime",
    customRender(working_time) {
      return `${working_time ?? 0} hour(s)`;
    },
    width: 120,
  },
  {
    title: "Explanation Rule",
    dataIndex: "explanationRule",
    key: "explanationRule",
    customRender(_, record) {
      return formatExplanationRule(record);
    },
    width: 300,
    align: "right",
  },
  {
    title: "Overtime Rule",
    dataIndex: "ot_type",
    key: "overtimeRule",
    customRender(ot_type) {
      if (!ot_type) return "";
      return OT_TYPES.find((otType) => otType.value === ot_type)?.label ?? "";
    },
    width: 120,
    align: "right",
  },
  {
    title: "Date Applied",
    dataIndex: "apply_date",
    key: "dateApplied",
    customRender(apply_date) {
      return formatDateStringToString(apply_date);
    },
    width: 120,
    align: "center",
  },
  {
    title: "Date Expired",
    dataIndex: "expire_date",
    key: "dateExpired",
    customRender(expire_date) {
      return formatDateStringToString(expire_date);
    },
    width: 120,
    align: "center",
  },
];
